import React from 'react';

import loadable from '@loadable/component';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { renderRoutes, RouteConfig } from '@/utils/router-config';

export const history = createBrowserHistory();

export const baseName = '/app/mlp/form';

export enum PageRouteEnum {
  Index = '/',
  Result = '/result',
  Code = '/code',
}

const routerConfig: RouteConfig[] = [
  {
    path: PageRouteEnum.Index,
    component: loadable<any>(() => import(/* webpackChunkName: "Index" */ './index/index')),
    title: '表单',
    exact: true,
  },
  {
    path: PageRouteEnum.Result,
    component: loadable<any>(() => import(/* webpackChunkName: "Result" */ './result')),
    exact: true,
  },
  {
    path: PageRouteEnum.Code,
    component: loadable<any>(() => import(/* webpackChunkName: "Code" */ './code')),
    exact: true,
  },
  { to: PageRouteEnum.Index },
];

export const Router = () => {
  // patchEnter(routerConfig);
  return <BrowserRouter basename={baseName}>{renderRoutes(routerConfig)}</BrowserRouter>;
};
